import React, { JSX } from 'react'
import { GridArea, OVERLAY_CANVAS, OverlayOrientation, chatAreas } from 'lib/overlayGrid'

export interface ChatAreaCanvasProps {
  orientation: OverlayOrientation
  cells: number
  scale: number
  renderArea: (area: GridArea, index: number) => React.ReactNode
  style?: React.CSSProperties
}

export const chatAreaCanvasStyle = (orientation: OverlayOrientation, scale: number): React.CSSProperties => {
  const { width, height } = OVERLAY_CANVAS[orientation]
  return { position: 'relative', width: width * scale, height: height * scale, overflow: 'hidden' }
}

export const chatAreaScreenStyle = (orientation: OverlayOrientation, scale: number): React.CSSProperties => {
  const { width, height } = OVERLAY_CANVAS[orientation]
  const style: React.CSSProperties = { position: 'absolute', left: 0, top: 0, width, height, overflow: 'hidden' }
  if (scale !== 1) {
    style.transform = `scale(${scale})`
    style.transformOrigin = 'top left'
  }
  return style
}

export const chatAreaBoxStyle = (area: GridArea): React.CSSProperties => ({
  position: 'absolute',
  left: area.box.x,
  top: area.box.y,
  width: area.box.width,
  height: area.box.height,
  overflow: 'hidden'
})

export const ChatAreaCanvas = ({ orientation, cells, scale, renderArea, style }: ChatAreaCanvasProps): JSX.Element => (
  <div
    data-testid='chat-area-canvas'
    data-orientation={orientation}
    style={style == null ? chatAreaCanvasStyle(orientation, scale) : { ...chatAreaCanvasStyle(orientation, scale), ...style }}
  >
    <div data-testid='chat-area-screen' style={chatAreaScreenStyle(orientation, scale)}>
      {chatAreas(orientation, cells).map((area, index) => (
        <div key={area.cells} data-testid='chat-area' style={chatAreaBoxStyle(area)}>
          {renderArea(area, index)}
        </div>
      ))}
    </div>
  </div>
)
